module.exports = __webpack_public_path__ + "img/pay.c17ff851.jpg";